import React, { createContext, useContext } from 'react';
import { FloatingHeader } from '@/components/layout/FloatingHeader';

/**
 * Marks that a public (signed-out) page already has the marketing header
 * rendered around it, so nested pages never stack a second one.
 */
const PublicShellContext = createContext(false);

export const useInPublicShell = () => useContext(PublicShellContext);

/**
 * Chrome for signed-out visitors: the marketing header and nothing member-only
 * (no coin chip, no notifications, no account avatar, no bottom member bar).
 */
export const PublicPageShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <PublicShellContext.Provider value={true}>
    <div className="min-h-dvh bg-background">
      <FloatingHeader />
      <div className="pt-16">{children}</div>
    </div>
  </PublicShellContext.Provider>
);

export default PublicPageShell;
